// Đăng nhập Office 365 (Microsoft Entra) — app "HANA Hub", đăng ký 29/Oct/2026.
// Đây là định danh công khai (không phải bí mật): SPA dùng Authorization Code + PKCE, KHÔNG có client secret.
export const AAD = {
  tenantId: '08e6946f-c1db-4c8f-96b8-c5c10dea53aa',
  clientId: 'a994329b-0cc4-41f5-a3d9-d670fcc215b1',
  authority: 'https://login.microsoftonline.com/08e6946f-c1db-4c8f-96b8-c5c10dea53aa',
  /** Scope để worker `api` kiểm token (Expose an API › access_as_user). */
  apiScope: 'api://a994329b-0cc4-41f5-a3d9-d670fcc215b1/access_as_user',
  graphScopes: ['openid', 'profile', 'email', 'offline_access', 'User.Read'],
  /** Redirect URI đã khai trong Entra (Authentication › Single-page application). */
  redirectPath: '/auth/callback',
  /** Trang trống tĩnh cho iframe silent của MSAL (cần đăng ký trong Azure AD, QĐ 31/Oct). */
  silentRedirectPath: '/blank.html',
  redirectOrigins: ['https://hub.hanalogisticsvn.com', 'https://hana-hub.pages.dev', 'http://localhost:5173'],
} as const;
